import { Component } from '@verndale/core';
import Swiper from 'swiper';
import { Navigation, Keyboard, Pagination, Controller } from 'swiper/modules';
import 'swiper/css/bundle';

class MediaGallery extends Component {
  public mediaGallerySwiper: {
    slideToLoop?: (index: number) => void | undefined;
  };

  constructor(el: HTMLElement) {
    super(el);
    this.mediaGallerySwiper = {};
    this.initSwiper();
  }

  setupDefaults() {
    this.dom = {
      el: this.el,
      swiperContainer: this.el.querySelector<HTMLElement>('.swiper'),
      swiperWrapper: this.el.querySelector<HTMLElement>('.swiper-wrapper'),
      swiperItems: this.el.querySelectorAll<HTMLElement>('.swiper-slide'),
      nextArrow: this.el.querySelector<HTMLElement>('.swiper-button-next'),
      prevArrow: this.el.querySelector<HTMLElement>('.swiper-button-prev'),
      pagination: this.el.querySelector<HTMLElement>('.swiper-pagination'),
      paginatioLightbox: document.querySelector<HTMLElement>('.lightbox .swiper-pagination'),
      lightbox: document.querySelector<HTMLElement>('.lightbox'),
      galleryImages: this.el.querySelectorAll<HTMLElement>('.media-gallery__img'),
      videoBtn: this.el.querySelector<HTMLElement>('.media-video'),
      tourBtn: this.el.querySelector<HTMLElement>('.media-tour'),
      videoContainer: document.querySelector<HTMLElement>('.modal-content.video'),
      imagesContainer: document.querySelector<HTMLElement>('.modal-content.images'),
      tourContainer: document.querySelector<HTMLElement>('.modal-content.tour')
    };

    this.initSwiper();
    this.checkUrlHash();
  }

  addListeners() {
    window.matchMedia('(max-width: 768px)').addEventListener('change', e => {
      if (e.matches) {
        (this.dom.galleryImages as NodeList).forEach(image => {
          image.addEventListener('click', this.handleImageClick.bind(this));
        });
      }
    });

    if (window.innerWidth < 768) {
      (this.dom.galleryImages as NodeList).forEach(image => {
        image.addEventListener('click', this.handleImageClick.bind(this));
      });
    }

    if (this.dom.videoBtn) {
      (this.dom.videoBtn as HTMLElement).addEventListener(
        'click',
        this.handleVideoClick.bind(this)
      );
    }
    if (this.dom.tourBtn) {
      (this.dom.tourBtn as HTMLElement).addEventListener('click', this.handleTourClick.bind(this));
    }
    window.addEventListener('lightboxSlideChange', e =>
      this.handleLigthboxSlideChange(e as CustomEvent)
    );
  }

  checkUrlHash() {
    const hash = window.location.hash.substring(1);
    const [mediaType] = hash.split(',');

    if (mediaType === 'video' && this.dom.videoBtn) {
      this.handleVideoClick();
    }
    if (mediaType === 'tour' && this.dom.tourBtn) {
      this.handleTourClick();
    }
    if (mediaType && mediaType.includes('image')) {
      if (window.innerWidth < 768) {
        this.handleImageClick();
      }
    }
  }

  handleImageClick() {
    (this.dom.lightbox as HTMLElement)?.classList.add('show');
    (this.dom.paginatioLightbox as HTMLElement)?.classList.remove('hide');
    (this.dom.videoContainer as HTMLElement)?.classList.add('hide');
    (this.dom.imagesContainer as HTMLElement)?.classList.remove('hide');
    (this.dom.tourContainer as HTMLElement)?.classList.add('hide');
  }

  handleVideoClick() {
    (this.dom.lightbox as HTMLElement)?.classList.add('show');
    (this.dom.paginatioLightbox as HTMLElement)?.classList.add('hide');
    (this.dom.videoContainer as HTMLElement)?.classList.remove('hide');
    (this.dom.imagesContainer as HTMLElement)?.classList.add('hide');
    (this.dom.tourContainer as HTMLElement)?.classList.add('hide');
  }

  handleTourClick() {
    (this.dom.lightbox as HTMLElement)?.classList.add('show');
    (this.dom.paginatioLightbox as HTMLElement)?.classList.add('hide');
    (this.dom.videoContainer as HTMLElement)?.classList.add('hide');
    (this.dom.imagesContainer as HTMLElement)?.classList.add('hide');
    (this.dom.tourContainer as HTMLElement)?.classList.remove('hide');
  }

  initSwiper() {
    Swiper.use([Navigation, Keyboard, Pagination, Controller]);
    const hash = window.location.hash.substring(1);
    const [mediaType, slideIndex] = hash.split(',');
    const initialSlide = mediaType?.includes('image') && slideIndex ? parseInt(slideIndex) - 1 : 0;

    this.mediaGallerySwiper = new Swiper(this.dom.swiperContainer as HTMLElement, {
      pagination: {
        el: this.dom.pagination as HTMLElement,
        type: 'fraction'
      },
      initialSlide,
      navigation: {
        nextEl: this.dom.nextArrow as HTMLElement,
        prevEl: this.dom.prevArrow as HTMLElement
      },
      loop: true,
      on: {
        realIndexChange: swiper => {
          if (!(this.dom.lightbox as HTMLElement)?.classList.contains('show')) {
            window.dispatchEvent(
              new CustomEvent('mediaGallerySlideChange', { detail: swiper.realIndex })
            );
          }
        }
      }
    });
  }

  handleLigthboxSlideChange(e: CustomEvent) {
    if (this.mediaGallerySwiper?.slideToLoop) this.mediaGallerySwiper?.slideToLoop(e.detail);
  }
}

export default MediaGallery;